import React, {useState, useEffect, useRef} from 'react';
import { Link } from 'react-router-dom';
import f_logo from '../assets/img/g_logo.png';
// import fb from '../../src/assets/icon/facebook.svg';
// import band from '../../src/assets/icon/band.png';
// import youtube from '../../src/assets/icon/youtube.svg';
// import insta from '../../src/assets/icon/insta.svg';
import { useLanguage } from '../hooks/useLanguage';

function Footer() {
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState(null); 
    const { currentLanguage } = useLanguage();
    
    
    const toggleSelect = () => setIsOpen(!isOpen);

    const handleOptionClick = (optionName) => {
      setSelected(optionName);
      setIsOpen(false);
    };

    const siteOptions = [
      { name: 'NHN', url: 'https://nhn.com/' },
      { name: 'NHNKCP', url: 'https://www.kcp.co.kr/' },
      { name: 'NHNCLOUD', url: 'https://www.nhncloud.com/' },
      { name: 'NHNAD', url: 'https://www.nhnad.com/' },
      { name: 'NHN PAYCO', url: 'https://company.payco.com/' },
    ]
    
    // 외부 클릭 감지 시, 셀렉박스 클로즈 
    const selectSite = useRef(null);
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (selectSite.current && !selectSite.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
  
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);
  
    return (
        <footer>
          {currentLanguage === 'ko' && (
            <div className='footer_inner'>
              {/* footer_left */}
              <div className='footer_left'>
                <div>
                  <div className='f_logo'>
                    <Link to="/">
                      <img src={f_logo} alt="f_logo"/>
                    </Link>
                  </div>
                  <div className='f_info'>
                    <ul>
                      <li>경기도 성남시 분당구 대왕판교로 645번길 16 플레이뮤지엄 NHN ACE</li>
                      <li>
                        <span>사업자등록번호 : 313-81-35670</span>
                        <span>대표메일 : atx@nhnace.com</span>
                      </li>
                      <li>Copyright ⓒ NHN ACE All rights reserved.</li>
                    </ul>
                  </div>
                </div>

                <ul className='f_menu'>
                  <li><Link to="/company/about">회사소개</Link></li>
                  <li><Link to="/terms">이용약관</Link></li>
                  <li style={{fontWeight:"800"}}><Link to="/privacy/acetrader">개인정보 처리방침</Link></li>
                  <li><Link to="https://careers.nhn.com/"  target="_blank" rel="noopener noreferrer">채용</Link></li>

                </ul>
              </div>
              {/* //footer_left */}

              {/* footer_right */}
              <div className='footer_right'>
                <div className={`family ${isOpen ? 'open' : ''}`} onClick={toggleSelect} ref={selectSite}>
                  <div className={`on ${selected ? '' : 'placeholder'}`} >
                    {selected || 'Family Site'}
                  </div>
                  {isOpen && (
                    <ul>
                      {siteOptions.map((site,idx) => (
                        <li key={idx}>
                          <a        
                            href={site.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => handleOptionClick(site.name)}>
                              {site.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                {/* <div className='sns_box'>
                  <span>
                    <img src={fb} alt="fb"/>
                  </span>
                  <span>
                    <img src={band} alt="band"/>
                  </span>
                  <span>
                    <img src={youtube} alt="youtube"/>
                  </span>
                  <span>
                    <img src={insta} alt="insta"/>
                  </span>
                </div> */}
              </div>
              {/* //footer_right */}
            </div>
          )}


          {currentLanguage === 'en' && (
            <div className="en_footer">
              <p>©NHNACE,INC</p>
            </div>
          )}
        </footer>
    );
}

export default Footer;